import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from '../../stores/authStore';
import { client } from '../client';
import { QueryKeys } from '../query-keys';

import type { Bundle } from '../../types/Policy';

type PolicyList = {
  result: {
    policies: Bundle[];
  };
};

const getPolicies = async () => {
  // TODO: we should rethink the response of these endpoints
  const [v1Policies, v2Policies] = await Promise.all([
    client.get<PolicyList>('/v1/policies'),
    client.get<PolicyList>('/v2/policies'),
  ]);

  return [
    ...(v1Policies.status === 200 ? v1Policies.data.result.policies : []),
    ...(v2Policies.status === 200 ? v2Policies.data.result.policies : []),
  ];
};

export const usePolicies = () => {
  const hasAccessToken = useAuthStore((state) => Boolean(state.accessToken));
  return useQuery({
    queryKey: QueryKeys.Policies,
    queryFn: getPolicies,
    enabled: hasAccessToken,
  });
};
